/**
 * @file: index.js
 * @status: Sovereign Entry Point (V2.0.0) - GLOBAL ENGINE ACTIVE
 * @authority: @CEO - Abdullah Ahmed Al-Zahrani
 * @description: نقطة الانطلاق الرئيسية؛ تفعيل الألوان السيادية، المحرك اللغوي، وبنية React.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// --- [ 1. تفعيل الهوية البصرية السيادية ] ---
import './index.css'; 

// --- [ 2. تفعيل المحرك اللغوي العالمي i18n ] ---
// هذا السطر هو "العقل" الذي يسمح للموقع بالتحول بين العربية والإنجليزية
import './i18n'; 

// --- [ 3. تدشين جذر المنظومة ] ---
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);